// Auth/SignIn.tsx
import React, {useContext, useEffect} from 'react';
import Head from "Core/components/Head";
import {AuthContext, AuthContextType} from "Auth/AuthContext";
import {useNavigation} from "Core/components/Header/HeaderProvider";
import {useNavigate} from "react-router-dom";
import logo from '../../Static/img/icon/logo-long.svg';
import AuthForm from "Auth/forms/AuthForm";
import {FC, FCAC} from "WideLayout/Layouts";
import {useTheme} from "Theme/ThemeContext";
import useMediaQuery from '@mui/material/useMediaQuery';
import {DOMAIN_URL} from "Auth/axiosConfig";

const SignIn = () => {
    const {isAuthenticated} = useContext(AuthContext) as AuthContextType;
    const navigate = useNavigate();
    const {plt, theme} = useTheme();
    const {hideMobileMenu, setProfileBtnVisible, setLogoContent, defaultLogoContent} = useNavigation();

    const isGt1200 = useMediaQuery('(min-width:1200px)');
    const isGt1000 = useMediaQuery('(min-width:1000px)');
    const isGt800 = useMediaQuery('(min-width:800px)');

    let scale = 1;
    let translateY = 0;
    let forcedHeight = '100%';

    if (isGt1200) {
        scale = 1.5;
        translateY = 5;
        forcedHeight = '990px';
    } else if (isGt1000) {
        scale = 1.25;
        translateY = 15;
        forcedHeight = '745px';
    } else if (isGt800) {
        scale = 1.1;
        translateY = 25;
        forcedHeight = '595px';
    }

    useEffect(() => {
        // setLogoContent(
        //     <FR
        //         color={plt.text.primary60}
        //         cls={`pt-6px fs-4 opacity-70 fw-bold tdn`}
        //         onClick={() => {
        //             window.location.href = '/';
        //         }}>
        //         LANDING
        //     </FR>
        // )
        setLogoContent(defaultLogoContent);
        setProfileBtnVisible(false);
        return () => {
            setLogoContent(defaultLogoContent);
            setProfileBtnVisible(true);
        };
    }, [setLogoContent, setProfileBtnVisible, theme]);

    useEffect(() => {
        if (isAuthenticated === null || !isAuthenticated) return;
        else {
            navigate('/profile');
            hideMobileMenu();
        }
    }, [isAuthenticated, navigate, hideMobileMenu]);

    if (isAuthenticated === null) return null;

    return (

        <FCAC
            h={forcedHeight}
            w={'90%'}
            mx={'auto'}
            maxW={400}>
            <FC style={{transform: `scale(${scale}) translateY(${translateY}px)`}}>
                <Head
                    title={'Вход | Лайф Хелп'}
                    description={'Помощь квалифицированных психологов от сервиса Лайф Хелп'}
                    robots={'noindex, nofollow'}
                    canonicalUrl={`${DOMAIN_URL}/auth`}
                />
                <img src={logo} className={'w-100 ps-2px mb-sm-2'} alt={'Logo'}/>
                <AuthForm/>
            </FC>
            <div></div>
        </FCAC>
    );
};

export default SignIn;
